/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Box, Grid, Typography} from "@mui/material";
import logo_creamos_home from '../../../Recursos/logo_creamos_home.png'

const Creamos_Home = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}

            size={{xs: 12, sm: 12, md: 12}}>
            <Grid container
                   justifyContent={'center'}
                   alignItems={'center'}
                   size={{xs: 12, sm: 4, md: 4}}>
                <Box
                    component="img"
                    src={logo_creamos_home}
                    sx={{width: 240, height: 'auto', }}
                    alt="Estamos para responder tus preguntas"
                />
            </Grid>

            <Grid container size={{xs: 12, sm: 8, md: 8}}>
                <Typography variant="h1" component="h3"
                            sx={{
                                background: 'linear-gradient(90deg, #495BFE 20%, #1E2880 110%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                fontSize: {xs: 32, md: 32},
                                fontWeight: 900,
                                textAlign: {xs: 'center', sm: 'left',md: 'left'},
                                paddingLeft: {sx:0, sm: 4, md: 4},
                                paddingY:6,

                            }}>
                    CREAMOS CONFIANZA, EFICIENCIA Y CALIDAD EN CADA COCINA.
                </Typography>
            </Grid>

        </Grid>
    )
}
export default Creamos_Home